"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colours = {
    blue: "#0098db",
    blueDark: "#0e6ea8",
    blueStrong: "#0088b7",
    blueMid: "#3fb2e5",
    blueLight: "#d4eef6",
    bluePale: "#edf8fd",
    green: "#96bc33",
    greenDark: "#729f40",
    greenStrong: "#8dbc50",
    greenMid: "#bed55f",
    greenLight: "#e7eed7",
    greenPale: "#f6f9ee",
    red: "#ed1c24",
    redDark: "#bc2026",
    redStrong: "#dd2f40",
    redMid: "#f44d4d",
    redLight: "#fbdadd",
    redPale: "#fdf0f2",
    orange: "#f79420",
    orangeDark: "#ea7627",
    orangeStrong: "#ff8a3b",
    orangeMid: "#f6b634",
    orangeLight: "#fae5d1",
    orangePale: "#fff6ed",
    grey: "#191919",
    greyDark: "#2d313a",
    greyStrong: "#a7a7a7",
    greyMid: "#dddddd",
    greyLight: "#efefef",
    greyPale: "#f9f9f9",
    white: "#ffffff",
    //temp
    success: "#64ae11",
    warning: "#f6b634",
    error: "#ef4e4e",
};
exports.default = colours;
